import { render, staticRenderFns } from "./OrderBackordered.vue?vue&type=template&id=5141ac83"
import script from "./OrderBackordered.vue?vue&type=script&lang=ts"
export * from "./OrderBackordered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports